// src/features/user/userSaga.js
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { getShopOrder, getShopOrderError, getShopOrderSuccess } from '../slice/orderSlice';
import { ApiClient } from "../../components/utils/apiClient";

import { BFF_URL } from '../../constant/stringConstants';
import { setServerErrors } from '../slice/appSlice';

function* getShopOrderCXML(action) {
  try {
    const authApiClient = new ApiClient(BFF_URL);
    const { orderReferenceId } = action.payload;
    const endpoint = `/order/generate-cxml-response/${orderReferenceId}`;

    const response = yield call([authApiClient, authApiClient.get], endpoint);
    yield put(getShopOrderSuccess(response));
  } catch (error) {
    console.error('Error fetching shop order CXML:', error);
    yield put(setServerErrors(true));
    yield put(getShopOrderError(error.data));
  }
}

function* orderSaga() {
  yield all([takeLatest(getShopOrder.type, getShopOrderCXML)]);
}

export default orderSaga;